import { Pipe, PipeTransform } from '@angular/core';
import { ZalamoDialogService } from 'ZalamoLibrary/src/lib/ui/zalamo-dialog/zalamo-dialog.service';
import { select, Store } from '@ngrx/store';
import { ShoppingCartState } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/actions/standalone';
import {
  selectPackagesInShop,
  selectProductsList,
} from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/actions/selector';
import { map } from 'rxjs/operators';

@Pipe({
    name: 'nameProduct',
    standalone: false
})
export class NameProductPipe implements PipeTransform {
  productsInShop$ = this.store.pipe(select(selectProductsList));

  constructor(private store: Store<{ shoppingCart: ShoppingCartState }>) {}

  transform(packageId: string) {
    return this.productsInShop$.pipe(
      map((packagesInShop) => {
        return packagesInShop.find((v) => v.productId === packageId).name;
      })
    );
  }
}
